<div
  highcharts-chart
  class="highcharts-light piechart-full-colors pie-chart-opacity-transition pie-chart-pad-legend pie-chart-clickable"
  [options]="data | transformChartOptions: doughnutChartTransformer"
  [sizeStrategy]="sizeStrategy"
  [runOutsideAngular]="true"></div>
